import { createFileRoute, Link } from "@tanstack/react-router";
import { Button } from "@mui/material";
import HgBreadcrumbs from "@/common/components/ui/atoms/HgBreadcrumbs";
import AdminUsersList from "@/common/components/views/AdminUsersList";
import { useUsersPermissions } from "@/pages/admin/users";

export const Route = createFileRoute("/app/admin/users/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { userCanEditAllUsers, userCanViewAllUsers } = useUsersPermissions();

  return (
    <>
      <HgBreadcrumbs
        options={[
          { title: "Admin", link: null, unlink: true },
          { title: "Users", link: null },
        ]}
      />

      <h1>User Management</h1>

      <p>
        <Button
          disabled={!userCanEditAllUsers}
          color="primary"
          component={Link}
          to="/app/admin/users/new"
          variant="contained"
          size="small"
        >
          Add User
        </Button>
      </p>

      <AdminUsersList
        itemsPerPage={25}
        renderVersion={0}
        tableSize="medium"
        userCanViewAllUsers={userCanViewAllUsers}
      />
    </>
  );
}
